module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-review-103b757c196c261010d8c97d32e2cbd8.svg";